import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { localVerticalHead } from "@/config/seoLocal";
import { redirectLegacyMunicipality } from "@/lib/legacyRedirects";
import { isCompactSlug } from "@/data/compact";
import { compactHead } from "@/data/compact/head";
import { loadCompactPage } from "@/data/compact/load";
import { assertServiceSlug } from "@/lib/slugGuards";

const ServiceSlugPage = lazy(() => import("@/pages/produkter/ServiceSlugPage"));
const CompactLandingPage = lazy(() => import("@/components/compact/CompactLandingPage"));

/** Compact keyword-sida (t.ex. /solceller/brf), annars produkt- eller kommunsida. */
export const Route = createFileRoute("/solceller/$slug")({
  beforeLoad: ({ params }) => {
    if (!isCompactSlug("solceller", params.slug)) redirectLegacyMunicipality("solceller", params.slug);
  },
  loader: async ({ params }) => {
    const compact = await loadCompactPage("solceller", params.slug);
    // Varken compact-sida, kommun eller produkt: riktig 404.
    if (!compact) await assertServiceSlug("solceller", params.slug, { municipalityPages: true });
    return { compact };
  },
  head: ({ params, loaderData }) =>
    loaderData?.compact
      ? compactHead(loaderData.compact, `/solceller/${params.slug}`)
      : localVerticalHead("solceller", params.slug),
  component: SlugRoute,
});

function SlugRoute() {
  const { compact } = Route.useLoaderData();
  return compact ? <CompactLandingPage page={compact} /> : <ServiceSlugPage vertical="solceller" />;
}
